import type { PlanCatalog } from "@/features/auth/api/plans";
import { useQuery } from "@tanstack/react-query";

export const usePlanCatalog = () =>
  useQuery<PlanCatalog>({
    queryKey: ["public-plans"],
    queryFn: async () => {
      const response = await fetch("/api/public/plans");
      if (!response.ok) {
        throw new Error(`Request failed (${response.status})`);
      }
      const data: PlanCatalog = await response.json();
      return data;
    },
  });
